import React from 'react';

function ArrowDown({ stroke = '#3F3C43', ...rest }) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M17.875 8.25L11 15.125L4.125 8.25"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export default ArrowDown;
